"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayEventsIncidenceSummaryDto = exports.DisplayEventIncidenceDateSlotDto = void 0;
const get_display_events_dto_1 = require("./get-display-events.dto");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class DisplayEventIncidenceDateSlotDto {
    date;
    hours;
}
exports.DisplayEventIncidenceDateSlotDto = DisplayEventIncidenceDateSlotDto;
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], DisplayEventIncidenceDateSlotDto.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.Min)(0, { each: true }),
    (0, class_validator_1.Max)(23 * 3600, { each: true }),
    __metadata("design:type", Array)
], DisplayEventIncidenceDateSlotDto.prototype, "hours", void 0);
class GetDisplayEventsIncidenceSummaryDto extends get_display_events_dto_1.DisplayEventSearchFiltersDto {
    displayIds;
    dates;
}
exports.GetDisplayEventsIncidenceSummaryDto = GetDisplayEventsIncidenceSummaryDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GetDisplayEventsIncidenceSummaryDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => DisplayEventIncidenceDateSlotDto),
    __metadata("design:type", Array)
], GetDisplayEventsIncidenceSummaryDto.prototype, "dates", void 0);
